<template>
    <div>
        <div class="not-found-container">
            <h1>404</h1>
            <p>Oops! Page not found.</p>
            <div class="mt-4">
                <button class="btn btn-danger" v-if="hasToken" @click="goTo('dashboard')">
                    Go to Dashboard
                </button>
                <button class="btn btn-danger" v-else @click="goTo('login')">
                    Go to Login
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import config from '@/services/config'

export default {
    name: 'NotFound',
    data() {
        return {
            hasToken: config.getCookie('token'),
        }
    },
    methods: {
        goTo(destiny) {
            this.$router.push({name: destiny})
        },
    }
}

</script>

<style scoped>
.not-found-container {
    margin: 0;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: sans-serif;
    color: #111;
}

h1 {
    font-size: 8rem;
    margin: 0;
    color: #DA1D62;
}

p {
    font-size: 1.25rem;
    margin: 10px 0;
    color: #555;
}

</style>